import { render } from "./HeadNoteWrite.vue?vue&type=template&id=55888a37"
import script from "./HeadNoteWrite.vue?vue&type=script&lang=js"
export * from "./HeadNoteWrite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__